import ScrollMagic from 'scrollmagic';

const ReviewCallout = () => {
  const controller = new ScrollMagic.Controller();

  const reviewCallouts = document.querySelectorAll('.page-section-review-callout');

  if ( !reviewCallouts.length ) return

  reviewCallouts.forEach(reviewCallout => {
    const sceneReview = new ScrollMagic.Scene({ triggerElement: reviewCallout })
      .setClassToggle(reviewCallout, 'active')
      //.addIndicators({ name: 'review content' }) // Uncomment if needed
      .addTo(controller);
  });
};

export default ReviewCallout;